import type {
  CollectionFacetFilters,
  PagedCollectionCardsRequest,
} from "modules/collections/details/model/collection";
import {
  CollectionCardSortOptions,
  SortOrderEnum,
} from "modules/collections/details/model/collection";
import {
  appendFacetQueryParams,
  normalizeFacetState,
} from "modules/common/cardFacets";
import type { FacetContract } from "modules/common/cardFacets";
import { BROWSE_PAGE_SIZE } from "utils/api-route.constants";

interface CollectionParams extends Record<string, unknown> {
  query: string;
  sort: CollectionCardSortOptions;
  order: SortOrderEnum;
  type: "all" | "traded" | "not-traded";
}

export function buildFiltersFromParams(
  params: CollectionParams,
  facetContract: FacetContract
): PagedCollectionCardsRequest {
  return {
    page: 1,
    perPage: BROWSE_PAGE_SIZE,
    query: params.query || "",
    sort: params.sort || CollectionCardSortOptions.CreatedAt,
    order: params.order || SortOrderEnum.Descending,
    type: params.type || "all",
    ...normalizeFacetState(params, facetContract, "collection"),
  } as PagedCollectionCardsRequest;
}

/**
 * Serializes every registered shared and game-specific facet. Adding a facet
 * to the game registry therefore updates cards, collections, trade lists,
 * city, and store queries without another hand-maintained parameter list.
 */
export function buildFacetQueryParams(
  filters: CollectionFacetFilters & Record<string, unknown>,
  facetContract: FacetContract
): string {
  const params = new URLSearchParams();
  const query = filters.query;
  const type = filters.type;
  if (typeof query === "string" && query) params.set("query", query);
  if (typeof type === "string" && type !== "all") params.set("type", type);
  if (filters.inTrade === true) params.set("in_trade", "true");
  appendFacetQueryParams(params, filters, facetContract);
  return params.toString();
}
